const deskTopStyles = `

    .nav {
        display: flex;
        position: relative !important;
        align-items: center;
        /* flex-wrap: wrap; */
        justify-content: space-between;
        background: var(--header-bg);
        min-height: 50px;
        height: auto;
        padding-right: 20px;
        color: var(--header-text);
        font-weight: 96;
        font-size: 14px;
        line-height: 20px;
        top: 0;
        left: 0;
        border-bottom: var(--group-heading-border-bottom);
    }
    
    .link {
        color: var(--header-text) !important;
    }
    
    .left-item {
        display: flex;
        align-items: center;
    }
    
    .nav .first-row svg {
        margin-left: 20px;
        margin-right: 21px;
        cursor: pointer;
        fill: var(--icon-color);
    }
    
    .nav .nav-item svg {
        margin-right: 0;
        /* margin-top: 21px;
        margin-bottom: 17px; */
        cursor: pointer;
        fill: var(--icon-color);
        opacity: 0.5;
    }
    
    .first-row {
        display: flex;
        align-items: center;
        /* margin-top: 20px;
        margin-bottom: 17px; */
    }
    
    .second-row {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        /* margin-top: 20px;
        margin-bottom: 17px; */
    }
    
    .divider {
        width: 1px;
        height: 16px;
        background: #fff;
        opacity: 0.2;
        margin-left: 21px;
        margin-right: 21px;
    }
    
    .nav-item {
        cursor: pointer;
        margin-left: 2px;
        margin-right: 2px;
        font-family: ErplyLadna !important;
        user-select: none;
        min-width: 50px;
        /* background-color: aqua; */
        display: flex;
        align-items: center;
        padding: 2px 10px;
        /* padding-left: 10px;
        padding-right: 10px; */
    }
    
    .active {
        color: var(--nav-hover);
        font-weight: 500;
    }
    
    .nav-item:hover {
        color: var(--nav-hover);
    }
    
    .first {
        margin-left: 0px;
    }
    
    .subitem-wrapper {
        position: absolute !important;
        display: flex;
        max-height: 700px;
        border-top: none;
        overflow-x: auto;
        overflow-y: auto !important;
        z-index: 100000;
        width: 100%;
        background: var(--nav-bg);
        top: 50px;
        color: var(--text-color);
    }
    
    .side-bar-inner {
        height: auto;
        width: 260px;
        border-radius: 0px;
        padding: 20px 30px 20px 30px;
        background: var(--side-inner-bg);
        text-align: center;
        /* display: flex;
        flex-direction: column; */
        /* align-items: center;
        justify-content: flex-start; */
    }
    
    .menu-groups {
        /* display: grid;
        grid-template-columns: auto auto auto; */
        padding: 20px 30px 20px 30px;
        display: flex;
        flex-wrap: wrap;
    }
    
    /* .menu-groups::after {
        content: "";
        display: table;
        clear: both;
    } */
    
    .menu-groups-item {
        height: auto;
        max-width: 258px;
        padding: 0px 15px 15px 15px;
        /* flex: 1 0 calc(25% - 10px); */
    }
    
    .menu-groups-title {
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        background: var(--group-heading-bg);
        padding: 10px;
        border-bottom: var(--group-heading-border-bottom);
        font-weight: bold;
        font-size: 12px !important;
        line-height: 16px;
        letter-spacing: 0.015em;
        text-transform: uppercase;
    }
    
    .menu-groups-children {
        padding: 3px 10px 10px 10px;
        display: flex;
        flex-direction: column;
    }
    
    .menu-groups-children a {
        margin-bottom: 10px;
        font-style: normal;
        font-weight: 96;
        line-height: 24px;
        letter-spacing: 0.005em;
    }
    
    .menu-groups-children a:hover {
        opacity: 0.5;
    }
    
    /* .side-bar-inner input {
        background: var(--input-bg);
        border: var(--input-border);
        border-radius: var(--border-radius);
        padding: 10px;
        width: 200px;
        color: var(--text-color); 
    } */
    
    input::placeholder {
        color: var(--input-placeholder-color);
    }
    
    label {
        display: grid;
        grid-template: 1fr / auto 1fr;
        /* gap: 7px; */
        background: var(--input-bg);
        border: var(--input-border);
        border-radius: var(--border-radius);
        padding: 10px;
        /* width: 237px; */
        color: var(--text-color);
        cursor: text;
    }
    
    label svg {
        fill: var(--icon-color);
        margin-left: 64px !important;
    }
    
    label:focus-within {
        border: var(--input-border);
    }
    
    label > input {
        outline: none;
        border: none;
        background: transparent;
        color: var(--text-color);
        width: 157%;
    }
    
    .quick-links {
        width: 100%;
        text-align: left !important;
        display: flex;
        flex-direction: column;
    }
    
    .quick-links-heading {
        margin-top: 20px;
        margin-bottom: 10px;
        display: inline-block;
        font-size: 14px;
        font-style: normal;
        font-weight: bold;
        line-height: 16px;
        letter-spacing: 0.015em;
        text-align: left;
        text-transform: uppercase;
        color: var(--quick-link-heading);
    }
    
    .quick-links-items {
        display: flex;
        align-items: center;
        margin-top: 15px;
        font-size: 14px;
        font-style: normal;
        font-weight: bold;
        line-height: 20px;
        letter-spacing: 0.0025em;
        text-align: left;
        width: 100%;
    }
    
    .quick-links-items:hover {
        opacity: 0.5;
    }
    
    /* .actions {
        display: flex;
        align-items: center;
        
    } */
    
    /* .actions svg {
        margin-top: 17px;
        margin-bottom: 15px;
        fill: rgba(255, 255, 255, 0.8);
        cursor: pointer;
    }
    
    .actions svg:hover {
        fill: #fff;
    } */
    
    .btn {
        padding: 5px;
        border: none;
        border-radius: 3px;
        cursor: pointer;
        font-weight: 96 !important;
        /* text-transform: uppercase; */
    }
    
    /* .user {
        height: 40px;
        width: 40px;
        border-radius: 100px;
        padding: 10px;
        background: var(--user-bg);
        cursor: pointer;
    } */
    .username {
        font-weight: bold !important;
    }
    
    .user:hover {
        color: var(--hover-text) !important;
        background: var(--nav-hover);
    }
    
    .lang:hover {
        color: #fff;
    }
    
    .action-bar {
        position: absolute;
        width: 725px;
        max-height: 100vh;
        /* left: 0px; */
        top: 50px;
        right: 0;
        background: var(--action-drop-bg);
        box-shadow: var(--nav-shadow);
        display: flex;
        /* justify-content: flex-end;
        align-items: flex-start; */
        padding: 20px 30px;
        z-index: 200000;
        color: var(--text-color);
    }
    
    .action-bar a {
        color: var(--text-color);
    }
    
    .action-bar a:hover {
        color: var(--nav-hover);
    }
    
    .item {
        width: auto;
        padding: 10px;
        display: flex;
        flex-direction: column;
    }
    
    .languages {
        width: 191px;
        padding: 10px;
        display: flex;
        flex-direction: column;
    }
    
    .drop-divider {
        background: var(--divider-bg);
        width: 1px;
        height: 320px;
        margin: 0px 20px 0px 20px;
    }
    
    .language-item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        cursor: pointer;
        justify-content: space-between;
    }
    
    .language-item:hover {
        color: var(--nav-hover);
    }
    
    .language-name {
        margin-left: 10px;
    }
    
    .language-item .right {
        display: flex;
        align-items: center;
    }
    
    .flex-item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }
    
    .flex-item:hover {
        color: var(--nav-hover);
    }
    
    .btn {
        width: 169px;
        height: 40px;
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        /* text-transform: capitalize; */
        border: none;
        transition: all 0.2s ease-in-out;
    }
    
    .btn:hover {
        transform: scale(1.02);
    }
    
    .btn svg {
        fill: inherit;
        margin-right: 10px;
    }
    
    .clock-out {
        background: var(--clock-out-bg);
        color: var(--clock-text);
    }
    
    .clock-out a {
        color: var(--clock-text) !important;
    }
    
    .btn-main {
        background: var(--btn-main-bg);
        color: var(--btn-main-text);
    }
    
    .btn-main a {
        color: var(--btn-main-text) !important;
    }
    
    .btn-main svg {
        fill: var(--btn-main-text);
    }
    
    .clock-out svg {
        fill: var(--clock-svg);
    }
    
    .info-group {
        cursor: pointer;
        color: var(--header-text);
    }
    
    .info-group:hover svg {
        fill: var(--nav-hover);
    }
    
    .info-group svg {
        fill: var(--header-text);
        /* width: 24px;
        height: 23px; */
    }
    
    .search-drop-down {
        background: var(--nav-bg);
        max-height: 600px;
        width: 100%;
        border-top: none;
        overflow-x: auto;
        overflow-y: auto !important;
        z-index: 100000;
        top: 51px;
        color: var(--text-color);
        padding: 30px 30px 30px 100px;
        position: absolute;
    }
    
    .content {
        width: 740px;
    }
    
    .close-icon {
        position: absolute;
        right: 74px;
        top: 22px;
        cursor: pointer;
        color: var(--icon-color);
    }
    
    .close-icon:hover {
        opacity: 1;
    }
    
    .s-quick-links {
        display: flex;
        flex-wrap: wrap;
    }
    
    .s-quick-item {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 8px 20px 8px 15px;
        background: var(--s-quick-link-bg);
        border-radius: 3px;
        margin: 0px 10px 15px 0px;
        color: var(--s-quick-link-color);
    }
    
    .s-quick-item:hover {
        background-color: var(--s-quick-link-hover);
    }
  
    .text-with-icon {
        color: var(--header-text);
        cursor: pointer;
      }

    
      .text-with-icon a {
        color: var(--header-text);
      }
      
      .text-with-icon:hover {
        color: var(--nav-hover);
      }

      .text-with-icon:hover a {
        color: var(--nav-hover);
      }

      .text-with-icon:hover svg {
        color: var(--nav-hover);
      }

      .close-icon-sub {
        position: absolute;
        right: 15px;
        top: 5px;
        color: var(--icon-color);
        cursor: pointer;
      }

      .close-icon-sub:hover {
        opacity: 1;
    }

`;

export default deskTopStyles;
